import React, {Component} from 'react';

import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form'
import ProductInput from "./ProductInput"
import Loader from "./Loader"
import {locale} from '../locale/AppLocale';
import trim from 'validator/lib/trim';
import isEmpty from 'validator/lib/isEmpty';

// import {NotificationManager} from '../Helpers/NotificationManager';;

import * as authActions from '../actions/authActions';

const validateLogin = (values, props) => {
    const errors = {};
    if (!values.email || isEmpty(trim(values.email))) {
        errors.email = locale.get('email_is_required');
    }

    if (!values.password || isEmpty(trim(values.password))) {
        errors.password = locale.get('password_is_required');
    }
    return errors;
}

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(values) {
        validateLogin(values);
        this.props.login(values)
    }

    render() {
        return <div className="login-page">

            <div className="block-1 block-1--main with-bg">

                <div className="container">
                    <div className="row">
                        <div className="col-8">
                            <div className="description">

                        <span className="lg-title">
                            هل تريد بيع منتجات على متجر shooq؟
                        </span>

                                <p className="desc">ابدأ البيع الآن حيث يتسوق الآلاف من المشترين يومياً ، أنت على بعد
                                    خطوات
                                    قليلة لتصبح بائعاً على متجر shooq
                                </p>

                                <a href="https://shooq.co.il/user/signup" className="default-btn green-bg">ابدأ ببيع منتجاتك الآن</a>


                            </div>
                        </div>
                        <div className="col-4">
                            <form className="form login-form"
                                  onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                                <h5 className="no-tm mb-20">{locale.get('login_to_your_account')}</h5>
                                <div className="login-form--body">
                                    <div className="form-group has-feedback has-feedback-left login-email-c ">
                                        <Field
                                            type="text"
                                            name="email"
                                            id="email"
                                            component={ProductInput}
                                            className="input"
                                            placeholder={locale.get('email_or_mobile')}
                                            field={{}}
                                            required="required"/>
                                        <div className="form-control-feedback">
                                            <i className="zicon-user"></i>
                                        </div>
                                    </div>
                                    <div className="form-group has-feedback has-feedback-left ">
                                        <Field
                                            type="password"
                                            name="password"
                                            id="password"
                                            component={ProductInput}
                                            className="input"
                                            placeholder={locale.get('password')}
                                            field={{}}
                                            required="required"/>

                                        <div className="form-control-feedback">
                                        <i className="zicon-key"></i>
                                        </div>

                                    </div>
                                    <div className="form-group login-options clearfix ptb-5">
                                        <label className="remember-me-c">
                                            <Field
                                                type="checkbox"
                                                name="remember"
                                                id="remember"
                                                component={ProductInput}
                                                className=""
                                                label={locale.get('remember_me')}
                                                placeholder={locale.get('remember_me')}
                                                field={{}}
                                            />
                                        </label>
                                        <a href="https://shooq.co.il/user/forgot-password"
                                           title="نسيت كلمة المرور؟" className="login-forgot-btn"> نسيت
                                            كلمة
                                            المرور؟ </a>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" disabled={this.props.auth.logging} className={`btn-1 btn--block ${this.props.auth.logging?'active':''}`}>
                                            <Loader completed={this.props.auth.logged}>
                                                تسجيل الدخول
                                            </Loader>
                                        </button>
                                    </div>

                                    <div className="login-divider"><span>أو سجل الدخول من خلال</span></div>

                                    <iframe className="social-login-frame" scrolling="no"
                                            src="https://accounts.shooq.co.il/auth/facebook-btn?param=lg"></iframe>
                                </div>

                            </form>

                        </div>
                    </div>
                    <div className="clearfix"></div>

                </div>

            </div>

            <div className="block-1 hidden-xs">

                <div className="container">

                    <span className="block-1--title">
                        لماذا عليك ان تبيع على متجر shooq؟
                    </span>

                    <div className="row">

                        <div className="col-3 mg-btm">

                            <div className="icon-div icon-div-hierarchical ">

                            </div>

                            <div className="icon-desc">

                    <span className="icon-title">الوصول الى آلاف المشترين
</span>

                                <p className="icon-info">العديد من المشترين سوف يجدون سلعك يومياً، مما يعني المزيد من
                                    المبيعات، أليس
                                    كذلك؟

                                </p>

                            </div>

                            <div className="clearfix"></div>

                        </div>

                        <div className="col-3 mg-btm">

                            <div className="icon-div icon-div-support">

                            </div>

                            <div className="icon-desc">

                    <span className="icon-title">دعم مستمر للبائعين
</span>

                                <p className="icon-info">لدينا فريق محترف لمساعدتك سواء كان من خلال مركز خدمة البائعين
                                    او من خلال قسم
                                    تطوير الاعمال
                                </p>

                            </div>

                            <div className="clearfix"></div>

                        </div>

                        <div className="col-3 mg-btm">

                            <div className="icon-div icon-div-easy-sell">

                            </div>

                            <div className="icon-desc">

                    <span className="icon-title">أضف سلعك مجاناً و بكل بسهولة
</span>

                                <p className="icon-info">أنشئ حسابك كبائع واعرض سلعك على الموقع دون دفع أي رسوم، وبخطوات
                                    بسيطة وسريعة

                                </p>

                            </div>

                            <div className="clearfix"></div>

                        </div>

                        <div className="clearfix"></div>

                    </div>

                    <div className="button-wrapper">

                        <a href="https://shooq.co.il/user/signup" className="default-btn green-bg">ماذا تنتظر ؟ ، ابدأ ببيع منتجاتك الآن</a>

                    </div>

                </div>

            </div>


            <div className="block-1 with-bg hidden-xs">

                <div className="container">

                    <span className="block-1--title">كيف يتم البيع؟</span>

                    <div className="step no-mg-r">

                        <div className="circular-box">

                            <div className="no">
                                <span className="number">1</span>
                            </div>
                            <div className="svg-icon svg-icon--store"></div>
                        </div>

                        <span className="step-title">
اعرض سلعك على
                            <span className="clearfix"></span>
                            متجر shooq
                </span>

                    </div>

                    <div className="next-arrow"></div>

                    <div className="step">

                        <div className="circular-box">

                            <div className="no">
                                <span className="number">2</span>
                            </div>
                            <div className="svg-icon svg-icon--order"></div>

                        </div>

                        <span className="step-title">
يقوم المشتري بطلب
                                                        <span className="clearfix"></span>
                            احدى سلعك
                </span>

                    </div>

                    <div className="next-arrow"></div>

                    <div className="step">

                        <div className="circular-box">

                            <div className="no">
                                <span className="number">3</span>
                            </div>

                            <div className="svg-icon svg-icon--preparation"></div>
                        </div>

                        <span className="step-title">
قم بتجهيز السلعة
                            <span className="clearfix"></span>
 للشحن
                </span>

                    </div>

                    <div className="next-arrow"></div>

                    <div className="step">

                        <div className="circular-box">

                            <div className="no">
                                <span className="number">4</span>
                            </div>
                            <div className="svg-icon svg-icon--money"></div>

                        </div>

                        <span className="step-title">
يقوم المشتري بالدفع وتحصل انت على نقودك عبر موقعنا
                </span>

                    </div>

                    <div className="next-arrow"></div>

                    <div className="step no-mg-l">

                        <div className="circular-box">

                            <div className="no">
                                <span className="number">5</span>
                            </div>
                            <div className="svg-icon svg-icon--shipping"></div>

                        </div>

                        <span className="step-title">
تقوم شركة الشحن باستلام الشحنة وتسليمها للمشتري
                </span>

                    </div>

                    <div className="clearfix"></div>

                </div>

            </div>



            {
                /*

                 <div className="block-1 with-gray-bg hidden hidden-xs">

                 <div className="container">

                 <span className="block-1--title">توصيات من بائعين على متجر shooq</span>

                 <div className="row">

                 <div className="col-3 mg-btm">

                 <div className="block-2">

                 <div className="block-2--desc">

                 <p>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد
                 النص
                 العربى، حيث يمكنك أن تولد التطبيق حيث يمكنك أن تولد التطبيق.</p>

                 </div>
                 <div className="block-2--footer">
                 <div className="block-2--circle" style={ {backgroundImage:`url("/images/test.png")`} }></div>
                 <span className="block-2--circle-title">
                 غادة القاسم
                 </span>
                 <div className="clearfix"></div>
                 </div>
                 </div>

                 </div>

                 <div className="col-3 ">

                 <div className="block-2">

                 <div className="block-2--desc">

                 <p>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد
                 النص
                 العربى، حيث يمكنك أن تولد التطبيق حيث يمكنك أن تولد التطبيق.</p>

                 </div>

                 <div className="block-2--footer">

                 <div className="block-2--circle" style={ {backgroundImage:`url("/images/test.png")`} }></div>

                 <span className="block-2--circle-title">
                 غادة القاسم
                 </span>

                 <div className="clearfix"></div>

                 </div>

                 </div>

                 </div>

                 <div className="col-3 ">

                 <div className="block-2">

                 <div className="block-2--desc">

                 <p>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد
                 النص
                 العربى، حيث يمكنك أن تولد التطبيق حيث يمكنك أن تولد التطبيق.</p>

                 </div>

                 <div className="block-2--footer">
                 <div className="block-2--circle" style={ {backgroundImage:`url("/images/test.png")`} }></div>
                 <span className="block-2--circle-title">
                 غادة القاسم
                 </span>

                 <div className="clearfix"></div>

                 </div>

                 </div>

                 </div>

                 <div className="clearfix"></div>

                 </div>

                 </div>
                 </div>
                 */
            }

        </div>;
    }


    componentDidMount() {
        const receiveMessage = (event) => {

            this.props.facebookLoginFailed()
            if(event){
                if (event.data === 'facebook_logged_in') {
                    this.props.check()
                } else {
                    // NotificationManager.error(locale.get('facebook_login_failed'))
                }
            }
        };
        if (window.addEventListener) {
            window.addEventListener("message", receiveMessage, false);
        } else {
            window.attachEvent("onmessage", receiveMessage);
        }
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {

        login: (data) => dispatch(authActions.login(data)),
        logout: () => dispatch(authActions.logout()),
        check: () => dispatch(authActions.check()),
        facebookLoginFailed: () => dispatch({
            type: 'AUTH_LOGIN_FAILED',
            results: {}
        })
    }
};


LoginForm = reduxForm({
    form: 'loginForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    touchOnChange: true,
    validate: validateLogin,
})(LoginForm);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
